var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.24609 14C2.24609 14 2.36741 14.8492 5.88213 18.364C9.39685 21.8787 15.0953 21.8787 18.6101 18.364C19.8553 17.1187 20.6594 15.5993 21.0223 14M2.24609 14V20M2.24609 14H8.24609M22.2461 10C22.2461 10 22.1248 9.15076 18.6101 5.63604C15.0953 2.12132 9.39685 2.12132 5.88213 5.63604C4.63686 6.88131 3.83279 8.40072 3.46992 10M22.2461 10V4M22.2461 10H16.2461",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw002);
export default __webpack_public_path__ + "static/media/refresh-cw-002.bc3586288a73a03a00ff9919b5397cc1.svg";
export { ForwardRef as ReactComponent };